import { createContext, useContext, useMemo } from 'react'

export const CARD_PADDINGS = ['none', 'sm', 'md'] as const
export type CardPadding = (typeof CARD_PADDINGS)[number]

export interface CardContext {
  padding: CardPadding
}

const CardContext = createContext<CardContext>(undefined)

export const CardProvider = ({ padding, children }) => {
  const value = useMemo(() => ({ padding }), [padding])

  return <CardContext.Provider value={value}>{children}</CardContext.Provider>
}

export const useCard = () => {
  const context = useContext(CardContext)
  if (context === undefined) {
    throw new Error('useCard must be used within a CardProvider')
  }
  return context
}
